import { Info } from 'icons';
import { rem } from 'polished';
import { AlertBox } from 'Shared/Form';
import Label from 'Shared/Form/Label';
import { Grid, GridItem } from 'Shared/Grid';
import PrimaryButton from 'Shared/PrimaryButton';
import styled, { css } from 'styled-components';
import { small } from 'utils';

export const StyledGrid = styled(Grid)`
  padding: 0;
`;

export const FormField = styled.div`
  margin-bottom: ${rem(24)};
  width: 100%;
`;

export const FieldLabel = styled(Label)`
  display: inline-flex;
  margin-bottom: ${rem(8)};
  color: ${({ theme }) => theme.colors.text.secondary};
`;

export const FieldLabelWrapper = styled.div`
  display: inline-flex;
`;

export const SubmitButton = styled(PrimaryButton)`
  width: 100%;
  ${small(css`
    width: auto;
  `)}
`;

export const AlertGridItem = styled(GridItem)`
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

export const SectionSeparator = styled.div`
  ${small(css`
    margin-bottom: ${rem(12)}};
  `)}
`;

export const InfoIcon = styled(Info).attrs(({ theme }) => ({
  primaryColor: theme.colors.primary,
  secondaryColor: theme.colors.text.secondary,
}))`
  display: flex;
  width: ${rem(20)};
  height: ${rem(20)};
  margin-left: ${rem(5)};
  margin-top: ${rem(9)};
`;

export const TooltipContainer = styled.div`
  display: inline-flex;
`;

export const AlertContainer = styled(AlertBox)`
  margin-bottom: ${rem(24)};
`;
